export default "__VITE_ASSET__33741288__"